import { Avatar, FlexBox, IconButton, Table } from '@dixa/lib-shared-habla';
import { boundMethod } from 'autobind-decorator';
import { TeamAgent } from 'lib-shared-legacy-types';
import { ampli } from 'lib-shared-tracking';
import { PureComponent } from 'react';


import styles from '../teamsAgents.module.scss';

type TeamsAgentsTableProps = {
  teamAgent: TeamAgent;
  showRemoveModal: (teamAgent: TeamAgent) => void;
};

export class TeamsAgentsTableRow extends PureComponent<TeamsAgentsTableProps> {
  @boundMethod
  handleClick() {
    ampli.settingsTeamDetailsAddAgentsButtonClicked();

    const { teamAgent, showRemoveModal } = this.props;
    showRemoveModal(teamAgent);
  }

  render() {
    const { teamAgent } = this.props;

    return (
      <Table.Tr>
        <Table.Td>
          <FlexBox alignItems="center">
            <div className={styles.avatarWrap}>
              <Avatar user={teamAgent} />
            </div>

            {teamAgent.name}
          </FlexBox>
        </Table.Td>
        <Table.Td>{teamAgent.email}</Table.Td>
        <Table.Td>
          <IconButton
            variant="tertiary"
            icon="trash"
            onClick={this.handleClick}
          />
        </Table.Td>
      </Table.Tr>
    );
  }
}
